import { render, staticRenderFns } from "./VerifyPayment.vue?vue&type=template&id=73693b0c&scoped=true"
import script from "./VerifyPayment.vue?vue&type=script&lang=ts"
export * from "./VerifyPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73693b0c",
  null
  
)

export default component.exports